import { render } from "./SearchResultCard.vue?vue&type=template&id=1804b264"
import script from "./SearchResultCard.vue?vue&type=script&lang=js"
export * from "./SearchResultCard.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\vue-workspace\\fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__